import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { CustomProperty } from '../../model/custom-property';

@Injectable()
export class CustomPropertyService extends DataService<CustomProperty> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, CustomProperty, progressBar, 'custom-property');
  }
}
